var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPriceOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_386_475)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_386_475",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_386_475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.83 16.41C18.8 16.48 18.77 16.55 18.74 16.61C18.79 16.56 18.83 16.49 18.85 16.43C18.95 16.27 19 16.09 19 15.9V15.5C19 15.82 18.94 16.13 18.83 16.41Z",
    fill: "#171E26",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.83 16.41C18.8 16.48 18.77 16.55 18.74 16.61C18.79 16.56 18.83 16.49 18.85 16.43C18.95 16.27 19 16.09 19 15.9V15.5C19 15.82 18.94 16.13 18.83 16.41Z",
    fill: "#171E26",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.71 19.29L20.31 17.89C20.75 17.2 21 16.38 21 15.5C21 13.94 20.21 12.56 19 11.76V4.1C19 3.49 18.51 3 17.9 3H3.1C2.49 3 2 3.49 2 4.1V15.9C2 16.51 2.49 17 3.1 17H12.26C12.87 18.75 14.54 20 16.5 20C17.38 20 18.2 19.75 18.89 19.31L20.29 20.71C20.49 20.9 20.74 21 21 21C21.26 21 21.51 20.9 21.71 20.71C22.1 20.32 22.1 19.68 21.71 19.29ZM12.03 15H4V5H17V11.03C16.84 11.01 16.67 11 16.5 11C14.18 11 12.28 12.75 12.03 15ZM19 15.9C19 16.09 18.95 16.27 18.85 16.43C18.83 16.49 18.79 16.56 18.74 16.61C18.46 17.16 17.99 17.6 17.41 17.83C17.13 17.94 16.82 18 16.5 18C15.68 18 14.96 17.61 14.5 17C14.19 16.59 14 16.06 14 15.5C14 15.33 14.02 15.16 14.05 15C14.28 13.86 15.29 13 16.5 13C16.67 13 16.84 13.02 17 13.05C18.14 13.28 19 14.29 19 15.5V15.9Z",
    fill: "#171E26",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.85 16.43C18.83 16.49 18.79 16.56 18.74 16.61C18.77 16.55 18.8 16.48 18.83 16.41L18.85 16.43Z",
    fill: "#171E26",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82 11.54C6.59 11.54 6.35 11.44 6.19 11.25C5.9 10.9 5.95 10.39 6.29 10.1L8.5 8.24999C8.8 7.99999 9.25 7.99999 9.55 8.24999L11.21 9.63999L13.65 7.59999C14 7.30999 14.51 7.35999 14.8 7.69999C15.09 8.04999 15.04 8.55999 14.7 8.84999L11.73 11.33C11.43 11.58 10.98 11.58 10.68 11.33L9.02 9.93999L7.33 11.35C7.18 11.48 6.99 11.54 6.81 11.54H6.82Z",
    fill: "#171E26",
    fillOpacity: 0.4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_386_475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceOff);
export default __webpack_public_path__ + "static/media/price_off.5f810e97df5ad57938ecf08efe0a3b8b.svg";
export { ForwardRef as ReactComponent };